import { render, staticRenderFns } from "./OfferElement.vue?vue&type=template&id=5639dabe&scoped=true"
import script from "./OfferElement.vue?vue&type=script&lang=js"
export * from "./OfferElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639dabe",
  null
  
)

export default component.exports